<template>
  <center>
    <div class="text-container">
      <h1>Oops! Page Not Found.</h1>
      <p>
        <!-- <a href="/">Go home?</a> -->
        <router-link to="/" exact>
          <p class="go-back">
            Go home
          </p>
        </router-link>
      </p>
    </div>
  </center>
</template>

<script>

  export default {
    name: 'NotFound'
  }

</script>

<style scoped>

  center {
    background-color: #ee7155;
  }

  .text-container {
    margin-top: 10rem;
  }

  h1 {
    color: var(--border);
    font-size: 2em;
    margin-bottom: 2rem;
  }

  a {
    text-decoration: none;
  }

  p {
    width: fit-content;
    display: flex;
    justify-content: center;
  }

  /* .explore-link {
    font-weight: bold;
    cursor: pointer;
    text-decoration: none;
    margin-top: 0.75rem;
    width: max-content;
    padding: 8px;
    margin: auto;
  } */

  .go-back {
    padding: 0.3rem 0.5rem;
    border-radius: 5px;
    background-color: #1d3336;
    color: whitesmoke;
    cursor: pointer;
    text-transform: uppercase;
  }

  /* .s1 {
    text-align: end;
  }

  .s1,
  .s2 {
    color: #1d3336;
  } */

  /* .mr {
    margin-left: auto;
  } */

</style>